import getFirebase from 'helper/getFirebase';

function getEventsFromSnapshot(snapshot) {
  if (snapshot.empty) {
    return [];
  }
  const docs = [];
  snapshot.forEach((docSnapshot) => {
    docs.push({ id: docSnapshot.id, ...docSnapshot.data() });
  });
  return docs;
}

export async function fetchActivityMessagesFromDateSn(classId, date, callback) {
  const { firebaseDB } = await getFirebase();
  const liveCLassCollection = firebaseDB.collection('live-class-events');
  const query = liveCLassCollection
    .where('classId', '==', classId)
    .where('updatedAt', '>=', date)
    .orderBy('updatedAt', 'desc');
  return query.onSnapshot((snapshot) => {
    const events = getEventsFromSnapshot(snapshot);
    callback(events.reverse());
  });
}

export async function fetchActivityMessagesBefore(classId, date) {
  const { firebaseDB } = await getFirebase();
  const liveCLassCollection = firebaseDB.collection('live-class-events');
  const query = liveCLassCollection
    .where('classId', '==', classId)
    .where('updatedAt', '<', date)
    .orderBy('updatedAt', 'desc')
    .limit(20);
  const snapshot = await query.get();
  const events = getEventsFromSnapshot(snapshot);
  return events.reverse();
}
